// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { UNCAUGHT_ERROR } from 'errors'
import { postDeletePaths } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'
import fetchAndSetProjectCompanies from './fetchAndSetProjectCompanies'

import {
  removeMultiplePaths,
  projectSummaryModalOpen,
  updateModalError,
  updateModalMessage,
} from 'redux/modules/projectSummary'

const deleteMultiplePaths = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { projectSummary } = getState()
      const projectId = projectSummary.get('projectId')
      const pathsToDelete = projectSummary.get('modalPathsSet').toJS()

      // for successful response message
      const numPaths = pathsToDelete.length
      const successMsg = `You have successfully deleted ${numPaths} path${numPaths > 1 ? `s` : ``}.`

      try {
        await postDeletePaths(pathsToDelete)

        // display a success message for deleting the path(s)
        dispatch(projectSummaryModalOpen('delete-paths'))
        dispatch(updateModalMessage(successMsg))

        // remove the paths from the UI
        dispatch(removeMultiplePaths(pathsToDelete))

        // update the project's companies list after the transaction
        dispatch(fetchAndSetProjectCompanies(projectId))
      } catch (err) {
        console.warn(err)
        const message = `Warning: ${err.message || UNCAUGHT_ERROR}`
        dispatch(updateModalError(message))
      }
    })
  )
)

export default deleteMultiplePaths
